// material-ui
import Box from '@mui/material/Box';

// ==============================|| AUTH - MODERN BACKGROUND ||============================== //

export default function AuthBackground() {
  return (
    <Box
      sx={{
        position: 'absolute',
        width: '100%',
        height: '100%',
        zIndex: 0,
        overflow: 'hidden',
        background: 'linear-gradient(145deg, #eef5f1 0%, #e2ebe6 40%, #f4f8f6 100%)',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: '-30%',
          right: '-20%',
          width: '600px',
          height: '600px',
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(31, 91, 64, 0.06) 0%, transparent 70%)',
          animation: 'float 8s ease-in-out infinite',
        },
        '&::after': {
          content: '""',
          position: 'absolute',
          bottom: '-20%',
          left: '-15%',
          width: '500px',
          height: '500px',
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(31, 91, 64, 0.04) 0%, transparent 70%)',
          animation: 'float 10s ease-in-out infinite reverse',
        },
        '@keyframes float': {
          '0%, 100%': { transform: 'translate(0, 0) scale(1)' },
          '50%': { transform: 'translate(30px, -20px) scale(1.05)' },
        },
      }}
    />
  );
}
